import { BreakPoints } from '../enums/index.js';
import useBreakPoint from '../useBreakPoint/index.js';

var useDevice = function useDevice() {
  var breakPoint = useBreakPoint();
  return {
    isMobile: breakPoint <= Number(BreakPoints.Small),
    isTablet: breakPoint > Number(BreakPoints.Small) && breakPoint <= Number(BreakPoints.Large),
    isDesktop: breakPoint > Number(BreakPoints.Large)
  };
};

export { useDevice as default };
//# sourceMappingURL=index.js.map
